import { ReactNode } from 'react';

// Types
import type { SwitchProps } from '@/components/base/Switch';
// Components
import Switch from '@/components/base/Switch';

type ToggleOptionProps = SwitchProps & {
    title: string;
    subtitle: string;
    toggle: boolean;
    onToggle?: () => void;
    children: ReactNode;
};

export const ToggleOption = ({
    title,
    subtitle,
    toggle,
    onToggle,
    children,
    ...restProps
}: ToggleOptionProps) => {
    return (
        <div className="flex flex-col gap-3 rounded-md border border-icoGray-300 p-5">
            <div className="flex justify-between gap-3">
                <span data-testid="toggle-option-title">
                    <p className="mb-1.5 text-icoBlack">{title}</p>
                    <p className="font-GMedium text-xs text-icoGray-400">{subtitle}</p>
                </span>
                <span className="flex items-center" data-testid="toggle-option-switch">
                    <Switch.Wrapper checked={toggle}>
                        <Switch onClick={onToggle} {...restProps} />
                    </Switch.Wrapper>
                </span>
            </div>

            {toggle ? children : null}
        </div>
    );
};
